import { render } from "./PatientNavigationNotesOverlay.vue?vue&type=template&id=a71d0028&scoped=true&lang=pug"
import script from "./PatientNavigationNotesOverlay.vue?vue&type=script&lang=js"
export * from "./PatientNavigationNotesOverlay.vue?vue&type=script&lang=js"

import "./PatientNavigationNotesOverlay.vue?vue&type=style&index=0&id=a71d0028&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a71d0028"]])

export default __exports__